// Import Vuetify theme from Design Tokens
import { lightTheme } from '@cnamts/design-tokens/src/colors';

/** Custom Vuetify color theme */
export const themeColors = {
	light: lightTheme
};
